
import React, { useState } from 'react';
import Lightroom from 'react-lightbox-gallery';
import './Gallery.css';

const Gallery = () => {
    const allImages = [
      // { src: "/images/home/gallery/gal1.jpg", desc: "Person wearing shoes", sub: "Gift Habeshaw" },
        { src: "/images/home/gallery/gal1.jpg",},
        { src: "/images/home/gallery/gal2.jpg", },
        { src: "/images/home/gallery/gal3.jpg", },
        { src: "/images/home/gallery/gal4.jpg", },
        { src: "/images/home/gallery/gal5.jpg",},
        { src: "/images/home/gallery/gal6.jpg",  },
        { src: "/images/home/gallery/gal7.jpg",  },
        { src: "/images/home/gallery/gal8.jpg", },
        { src: "/images/home/gallery/gal9.jpg",  },
        { src: "/images/home/gallery/gal10.jpg", },
        { src: "/images/home/gallery/gal11.jpg", },
        { src: "/images/home/gallery/gal12.jpg" },
        { src: "/images/home/gallery/gal13.jpg" },
        { src: "/images/home/gallery/gal14.jpg" },
        { src: "/images/home/gallery/gal15.jpg" },
        { src: "/images/home/gallery/gal16.jpg" },
        { src: "/images/home/gallery/gal17.jpg" },
        { src: "/images/home/gallery/gal18.jpg" },
        { src: "/images/home/gallery/gal19.jpg" },
        { src: "/images/home/gallery/gal20.jpg" },
        { src: "/images/home/gallery/gal21.jpg" },
        { src: "/images/home/gallery/gal22.jpg" },
        { src: "/images/home/gallery/gal23.jpg" },
        { src: "/images/home/gallery/gal24.jpg" },
        { src: "/images/home/gallery/gal25.jpg" },
        { src: "/images/home/gallery/gal26.jpg" },
        { src: "/images/home/gallery/gal27.jpg" },
        { src: "/images/home/gallery/gal28.jpg" },
        { src: "/images/home/gallery/gal29.jpg" },
        { src: "/images/home/gallery/gal30.jpg" },
        { src: "/images/home/gallery/gal31.jpg" },
        { src: "/images/home/gallery/gal32.jpg" },
        { src: "/images/home/gallery/gal33.jpg" },
        { src: "/images/home/gallery/gal34.jpg" },
        { src: "/images/home/gallery/gal35.jpg" },
        { src: "/images/home/gallery/gal36.jpg" },
        { src: "/images/home/gallery/gal37.jpg" },
        { src: "/images/home/gallery/gal38.jpg" },
        { src: "/images/home/gallery/gal39.jpg" },
    ];

    const [visibleImages, setVisibleImages] = useState(6);
    const [isLoading, setIsLoading] = useState(false);

    const settings = {
        columnCount: {
            default: 3,
            mobile: 2,
            tab: 3,
        },
        mode: "dark",
        enableZoom: false,
    };

    const handleLoadMore = () => {
        setIsLoading(true);
        setTimeout(() => {
          setVisibleImages((prevVisible) => prevVisible + 6);
          setIsLoading(false);
        }, 1000); // Simulate a delay for loading
      };
    
    return (
        <div>
            <Lightroom
                images={allImages.slice(0, visibleImages)}
                settings={settings}
                renderItem={({ src, desc, sub }) => (
                    <div className="image-container">
                        <img
                            src={src}
                            alt="img"
                            className="custom-image"
                        />
                        {/* {desc && <p className="image-desc">{desc}</p>} */}
                    </div>
                )}
            />
               {visibleImages < allImages.length && (
                 <div className="flex justify-center items-center mt-4">
                 {isLoading ? (
                   <p className="loader h-4"></p> // Add your custom loader CSS
                 ) : (
                   <button className="btn btn-primary" onClick={handleLoadMore}>
                     View More
                   </button>
                 )}
               </div>
            )}
        </div>
    );
};
export default Gallery;





// import React from 'react';
// import Lightroom from 'react-lightbox-gallery';

// const Gallery = () => {
//     const images = [
//         {

//             src: "/images/gallery/gal1.jpg",
//             desc: "Person wearing shoes",
//             sub: "Gift Habeshaw",
            
//         },
//         {
//             src: "/images/gallery/gal2.jpg",
//             desc: "Blonde woman wearing sunglasses smiling at the camera",
//             sub: "Dmitriy Frantsev",
//         },
//         {
//             src: "/images/gallery/gal3.jpg",
//             sub: "Harry Cunningham",
//         },
//         {
//             src: "/images/gallery/gal4.jpg",
//             desc: "Jaipur, Rajasthan, India",
//             sub: "Liam Baldock",
//         },
//         {
//             src: "/images/gallery/gal5.jpg",
//             sub: "Verne Ho",
//         },
//         {
//             src: "/images/gallery/gal6.jpg",
//             desc: "Rann of Kutch, India",
//             sub: "Hari Nandakumar",
//         },
//     ];

//     const settings = {
//         columnCount: {
//             default: 3,
//             mobile: 2,
//             tab: 3,
//         },
//         mode: "dark",
//         enableZoom: false,
//     };

//     return (
//     <div>   <Lightroom images={images} settings={settings}  />;
//     <div className="flex justify-center items-center mt-4">
//   <button className="btn btn-primary">more</button>
// </div>

//     </div>)
 
// };

// export default Gallery;

